var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkCircleGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 20",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00B287",
    d: "M7,14c-3.309,0-6-2.691-6-6s2.691-6,6-6c1.119,0,2.2,0.307,3.126,0.886c0.233,0.146,0.305,0.455,0.158,0.689   C10.138,3.811,9.83,3.88,9.595,3.734C8.829,3.254,7.931,3,7,3C4.243,3,2,5.243,2,8s2.243,5,5,5s5-2.243,5-5   c0-0.458-0.063-0.905-0.189-1.328c-0.078-0.265,0.072-0.543,0.337-0.622c0.27-0.078,0.544,0.073,0.622,0.337   C12.923,6.903,13,7.445,13,8C13,11.309,10.309,14,7,14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B287",
    d: "M7,9.5c-0.128,0-0.256-0.049-0.354-0.146l-2.5-2.5c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0L7,8.293   l6.146-6.146c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707l-6.5,6.5C7.256,9.451,7.128,9.5,7,9.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleGreen);
export default __webpack_public_path__ + "static/media/checkmark_circle_green.c6802d893ba0e2e1b089c4b1e15cd71d.svg";
export { ForwardRef as ReactComponent };